export const BASE_URL = import.meta.env.VITE_BASE_URL; //"https://www.rechtsportal24.de"
export const STRIPE_PUBLIC_KEY = import.meta.env.VITE_STRIPE_PUBLIC_KEY; // "pk_test_nNPn970uQfv3FalmzvX2hmo000W2BH9nhD"
